module.exports = "/_next/static/resources/single-f0c4938ab3738d2a496029d7e1c8dfd8.webp";